<div fxLayout="column" fxLayoutGap="32px" class="properties-container">
  <div class="info-container" *ngIf="loading">
    <section>
      <div class="connection-pending-header">
        <div fxLayout="row" fxLayout.xs="column" fxLayoutAlign="center center">
          <img src="/assets/images/hospitable.png" alt="Hospitable Logo" class="logo hospitable-logo" />
          <img src="/assets/iconography/connect.svg" class="connect-img" />
          <img src="/assets/images/connected-accounts/agoda.svg" alt="Agoda Logo" class="logo agoda-logo" />
        </div>
        <p class="header-description">This might take a few moments...</p>
      </div>

      <div fxLayout="column" fxLayoutAlign="center center" fxLayoutGap="40px">
        <mat-spinner diameter="80"></mat-spinner>

        <div fxLayout="column" fxLayoutAlign="center center" fxLayoutGap="10px">
          <strong class="larger-description">Do not close this screen.</strong>
          <span class="larger-description">We are waiting to receive data from Agoda</span>
        </div>
      </div>
    </section>
  </div>

  <div class="flex flex-col justify-stretch gap-8" *ngIf="!loading">
    <h2>Review properties</h2>

    <section class="properties-box">
      <div
        class="properties-box-header"
        fxLayout="column"
        fxLayout.gt-xs="row"
        fxLayoutAlign="start start"
        fxLayoutAlign.gt-xs="space-between center">
        <strong>
          {{ connectedProperties.length }}
          {{ 'properties' | pluralize: connectedProperties.length }} connected.
        </strong>
      </div>

      <div class="space-y-4">
        <ng-container *ngFor="let property of properties">
          <div
            *ngIf="property.name"
            fxLayout="column"
            fxLayoutGap="4px"
            fxLayoutAlign="start start"
            class="full-width border-b border-gray-200 pb-4 last:border-b-0 last:pb-0">
            <div class="full-width" style="align-self: flex-start">
              <span fxLayout.gt-xs="row" fxLayoutGap="8px" fxLayoutAlign.gt-xs="space-between center" class="full-width">
                <span fxLayout="row" fxLayoutGap="8px" fxLayoutAlign="start center">
                  <img
                    [src]="property.main_photo_url ? property.main_photo_url : '/assets/images/image-error.png'"
                    class="property__img"
                    fxHide.lt-sm
                    style="width: 36px; height: 36px" />
                  <span fxLayout="column" fxLayoutAlign="start start">
                    <span>
                      <strong>{{ property.name }}</strong>
                    </span>
                    <span class="night text__small clamp">{{ property.address }}</span>
                  </span>
                </span>
                <div>
                  <span class="property-warning badge badge-grass">
                    <img src="/assets/iconography/check.svg" onload="SVGInject(this)" />
                    <span *ngIf="property.already_connected">Already</span>
                    Connected
                  </span>
                </div>
              </span>
            </div>
          </div>
        </ng-container>

        <ng-container *ngFor="let propertyId of unmatchedPropertyIds">
          <div
            fxLayout="column"
            fxLayoutGap="4px"
            fxLayoutAlign="start start"
            class="full-width border-b border-gray-200 pb-4 last:border-b-0 last:pb-0">
            <div class="full-width" style="align-self: flex-start">
              <span fxLayout.gt-xs="row" fxLayoutGap="8px" fxLayoutAlign.gt-xs="space-between center" class="full-width">
                <span fxLayout="row" fxLayoutGap="8px" fxLayoutAlign="start center">
                  <img
                    src="/assets/images/image-error.png"
                    class="property__img"
                    fxHide.lt-sm
                    style="width: 36px; height: 36px" />
                  <span fxLayout="column" fxLayoutAlign="start start">
                    <span>
                      <strong>{{ propertyId }}</strong>
                    </span>
                  </span>
                </span>
                <div>
                  <span class="property-warning badge badge-danger">
                    <img src="/assets/iconography/delete.svg" onload="SVGInject(this)" />
                    Not connected
                  </span>
                </div>
              </span>
            </div>
          </div>
        </ng-container>
      </div>
    </section>

    <section class="flex flex-col justify-stretch gap-4" *ngIf="unmatchedPropertyIds.length > 0">
      <sbnb-note [type]="NoteType.Info" content="Properties not found in Agoda">
        <div class="note-banner__slot">
          <p>Hospitable is not set as channel manager for {{ connectedProperties.length ? 'some' : 'any' }} of these Agoda properties.
            Changes to channel manager settings take up to 24 hours to take effect.</p>
        </div>
      </sbnb-note>

      <p class="mb-0">Confirm below if you've set Hospitable as channel manager. We will check periodically and email you when property is ready to be connected.</p>

      <div *ngIf="!retryInitiated">
        <div class="flex flex-col gap-2">
          <mat-checkbox [(ngModel)]="hasConfirmedChannelManager" data-agoda-channel-manager-confirmation
            class="text-sm [&_.mat-checkbox-layout]:bg-transparent">
            I assigned Hospitable as these properties' channel managers in Agoda YCS.
          </mat-checkbox>

          <sbnb-button
            data-retry-agoda-connection
            size="mini"
            type="secondary"
            [label]="retryInProgress ? 'Initiating retry...' : 'Retry connection in background'"
            [loading]="retryInProgress"
            [disabled]="!hasConfirmedChannelManager"
            (clicked)="retryConnectionInBackground()">
          </sbnb-button>
        </div>
      </div>
      <div *ngIf="retryInitiated">
        <div class="rounded-md bg-green-50 p-4">
          <div class="flex">
            <div class="flex-shrink-0">
              <sbnb-icon icon="check" class="block mt-1 text-green-400"></sbnb-icon>
            </div>
            <div class="ml-3">
              <p class="my-0 text-sm font-medium text-green-800">
                We will check the connection status in the background and send you an email when it's available.
                <strong *ngIf="connectedProperties.length">You can continue to the next step for connected properties.</strong>
                <strong *ngIf="!connectedProperties.length">You can close this page.</strong>
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>

    <div
      class="flex justify-end gap-4">
      <sbnb-button label="Back" type="secondary" (click)="back()" *ngIf="!properties"></sbnb-button>
      <sbnb-button
        data-intercom-target="agoda-property-ids-continue"
        [label]="connectedProperties.length ? 'Continue' + (unmatchedPropertyIds.length ? ' with connected properties' : '') : 'Finish'"
        [loading]="loading"
        (click)="progress()"></sbnb-button>
    </div>
  </div>
</div>
